import { BASE_API_URL } from 'services/api/index';

export const passwordInputEndpoint = `${BASE_API_URL}/signup/check-password-strength/`;
